import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NAV_ITEMS } from 'src/app/core/config/nav-items';
import { AuthService } from 'src/app/core/services/auth.service';

/** Lands on '/', then routes the user to the first nav item their roles unlock. */
@Component({
  selector: 'app-home-redirect',
  template: ''
})
export class HomeRedirectComponent implements OnInit {
  constructor(private readonly authService: AuthService, private readonly router: Router) {}

  ngOnInit(): void {
    const roles = this.authService.currentUser?.roles ?? [];
    const landing = NAV_ITEMS.find((item) => item.roles.some((role) => roles.includes(role)));
    this.router.navigateByUrl(landing?.route ?? '/login');
  }
}
